import { render, staticRenderFns } from "./CaseResponseDoc.vue?vue&type=template&id=707a2ec8&lang=pug&"
import script from "./CaseResponseDoc.vue?vue&type=script&lang=js&"
export * from "./CaseResponseDoc.vue?vue&type=script&lang=js&"
import style0 from "./CaseResponseDoc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFlex,VIcon,VSnackbar})
